import { createContext } from 'react'
import { AcatsSearchDto } from '../../../api/types'
import {
  AccountDetailsState,
  AccountOwnerState,
  AccountSearchState,
  CorrespondentState,
  TransferSearchState,
} from '../../../types'
import { History } from 'history'

export const INITIAL_ACCOUNT_DETAILS_STATE: AccountDetailsState = {
  accountDetails: undefined,
  loadingResult: false,
}

export const INITIAL_ACCOUNT_OWNERS_STATE: AccountOwnerState = {
  accountOwners: [],
  loadingAccountOwners: false,
}

export const INITIAL_ACCOUNT_SEARCH_STATE: AccountSearchState = {
  accountResults: [],
  loadingResults: false,
  errorMessage: undefined,
  searchTerm: '',
}

const EMPTY_CORRESPONDENT = {
  code: '',
  name: '',
}

export const INITIAL_CORRESPONDENT_STATE: CorrespondentState = {
  correspondent: EMPTY_CORRESPONDENT,
  loadingResult: false,
}

export const INITIAL_TRANSFER_SEARCH_STATE: TransferSearchState = {
  acatsSearchDto: {},
  errorMessage: undefined,
  loadingResults: false,
  transferResults: [],
}

export interface SearchProps {
  accountDetailsState: AccountDetailsState
  accountOwnerState: AccountOwnerState
  accountSearchState: AccountSearchState
  correspondentState: CorrespondentState
  transferSearchState: TransferSearchState
  getAccountDetails: (accountNumber: string) => void
  getAccountOwners: (accountNumber: string) => void
  getCorrespondent: (accountNumber: string) => void
  searchAccounts: (searchTerm: string, history: History) => void
  searchTransfers: (history: History, acatsSearchDto?: AcatsSearchDto) => void
}

export const SearchContext = createContext<SearchProps>({
  accountDetailsState: INITIAL_ACCOUNT_DETAILS_STATE,
  accountOwnerState: INITIAL_ACCOUNT_OWNERS_STATE,
  accountSearchState: INITIAL_ACCOUNT_SEARCH_STATE,
  correspondentState: INITIAL_CORRESPONDENT_STATE,
  transferSearchState: INITIAL_TRANSFER_SEARCH_STATE,
  getAccountDetails: () => {},
  getAccountOwners: () => {},
  getCorrespondent: () => {},
  searchAccounts: () => {},
  searchTransfers: () => {},
})
